import { render } from "./MentionsVigeo.vue?vue&type=template&id=10a27cf8&scoped=true"
import script from "./MentionsVigeo.vue?vue&type=script&lang=js"
export * from "./MentionsVigeo.vue?vue&type=script&lang=js"

import "./MentionsVigeo.vue?vue&type=style&index=0&id=10a27cf8&lang=scss&scoped=true"

import exportComponent from "/builds/fr.swissLife.nxtCms/cms/nxtcms/nxt-front-ui/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a27cf8"]])

export default __exports__